<template>
  <div class="base-switch">
    <div class="wrapper">
      <div
        :class="['option', 'option-on', { 'active' : selectedValue }]"
        @click="setSelectedValue(true)"
      >
        {{ $t(optionOnName) }}
      </div>
      <div
        :class="['option', 'option-off', { 'active' : !selectedValue }]"
        @click="setSelectedValue(false)"
      >
        {{ $t(optionOffName) }}
      </div>
      <span :class="['indicator', indicatorPositionClass ]"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSwitch',
  props: {
    optionOnName: {
      type: String,
      default: 'general.switch.on.name'
    },
    optionOffName: {
      type: String,
      default: 'general.switch.off.name'
    },
    defaultSelected: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedValue: true 
    }
  },
  computed: {
    indicatorPositionClass() {
      return this.selectedValue ? 'left-position' : 'right-position';
    }
  },
  methods: {
    setSelectedValue(value) {
      this.selectedValue = value;
      this.$emit('valueChanged', this.selectedValue);
    }
  },
  created() {
    if(this.defaultSelected !== undefined || this.defaultSelected !== null) {
      this.selectedValue = this.defaultSelected;
    }
  }
}
</script>

<style lang="scss" scoped>
.base-switch {
  min-width: 120px;
}

.wrapper {
  border-radius: 4px;
  border: 1px solid rgba(#262A30, 0.06);
  padding: 3px;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
}

.indicator {
  position: absolute;
  top: 3px;
  left: 3px;
  transition: all 0.4s ease-in-out;
  width: 50%;
  height: 32px;
  border-radius: 2px;
  
  &.left-position {
    background: #246AC7;  
  }

  &.right-position {
    left: calc(100% - 50% - 3px);
    background: #262A30;
  }
}

.option {
  font-size: 14px;
  line-height: 18px;
  width: 50%;
  height: 32px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &.active {
    color: #fff;
  }
}
</style>
